import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  container: {
    paddingHorizontal: indent,
    paddingTop: indent * 1.5,
  },
  noResultsContainer: {
    paddingTop: indent * 6,
    alignSelf: 'center',
  },
  icon: {
    width: 56,
    height: 56,
    fontSize: 56,
    alignSelf: 'center',
    marginBottom: indent * 1.8,
  },
  heading: {
    marginBottom: indent * 0.5,
  },
  text: {
    textAlign: 'center',
  },
});
